import {useEffect,useState} from 'preact/hooks';
import {pvpState} from '@/pvp';
import {useClient} from '@/ui/context';
import {HUD_Z} from '@/ui/consts';
export function PkWarning(){
 const state=pvpState(useClient());const[,refresh]=useState(0);
 useEffect(()=>state.subscribe(()=>refresh(n=>n+1)),[state]);
 if(!state.forced())return null;
 return <div role='status' class='fixed left-1/2 -translate-x-1/2 rounded border border-error bg-base-300 px-3 py-2 text-center text-xs text-error shadow-lg' style={{bottom:'calc(env(safe-area-inset-bottom, 0px) + 5rem)',zIndex:HUD_Z+1,maxWidth:'calc(100vw - 1rem)'}} onPointerDown={e=>e.stopPropagation()}>
  PK enabled — be careful! {state.mobileEnabled?'Tap Shift or the PK button to disable.':'Release Shift + Ctrl to disable.'}
 </div>;
}
